import React from 'react';
import '../style/LevelPage.scss';

import { Link } from "react-router-dom";

import Header from "../components/Header";
import Api from "../components/Api";

class LevelPage extends React.Component {
  
	render() {
		return (
			<div className="container level-page">
				
				<Header />
			
				<div className="content-box">
					<Link to="/puzzle">Start Puzzle</Link>
					
					<Api />
					
				</div>
				
			</div>
		);
	}
  
}

export default LevelPage;